import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入 swiper.css
import 'swiper/css/swiper.css'

import '@/styles/index.scss'

import request from '@/utils/request' 

Vue.config.productionTip = false
Vue.prototype.$http = request
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')


